export const audienceValidationConfig = {
  name: {
    required: true,
    pattern: /^[\w-():\s]*$/,
    customErrorMessage: {
      pattern: 'Invalid audience name'
    }
  }
};
